<template lang="html">
    <div style="width:100%;background-color:#f3f3f3;height:100%; position: relative">
      <div class="logo-header">

         <v-slide-x-transition mode="out-in" class="hotsite-body" v-if="logoProviderFeedback === ''">
          <div class="titulo-logo mb-4 float-l">
            <img v-show="!loading" src="../../assets/logo.png" alt=""> <h4 v-show="!loading">CondoPlaza</h4>
          </div>
        </v-slide-x-transition>

        <v-slide-x-transition mode="out-in" class="hotsite-body" v-else>
          <img :src="logoProviderFeedback" :key="logoProviderFeedback" alt="">
        </v-slide-x-transition>

        <v-progress-linear v-show="loading" v-bind:indeterminate="true" height="2" class="progrees-line" color="red" background-color="white"></v-progress-linear>
      </div>
      <v-container grid-list-md text-xs-center>
       <v-layout row wrap>
         <v-flex xs10 offset-xs1>
          <h4 style="color: gray;">
            Fique tranquilo!
          </h4>
           <h6 style="color: gray;">
              {{defaultMessageHeader}}
          </h6>
         </v-flex>
         <v-slide-y-reverse-transition mode="out-in" v-if="!dataSent">
           <v-flex xs10 offset-xs1>
             <v-card class="elevation-1">
               <v-card-text>
                 <p>
                   {{defaultMessageBody}}
                 </p>
                 <v-text-field v-model="formTextarea" multi-line label="Comente aqui...">
                 </v-text-field>
                 <v-btn block color="success" @click="sendFormData">Gravar</v-btn>
               </v-card-text>
             </v-card>
           </v-flex>
         </v-slide-y-reverse-transition>
         <v-slide-y-reverse-transition mode="out-in" v-else>
           <v-flex xs10 offset-xs1>
             <v-card class="elevation-1">
               <v-card-text>
                 <h5>
                     Muito Obrigado 😄
                 </h5>
               </v-card-text>
             </v-card>
           </v-flex>
        </v-slide-y-reverse-transition>

        </v-layout>
      </v-container>
     </v-flex>
    </div>
</template>

<script>
export default {
  props: {
    token: {
      type: String
    },
    type: {
      type: String
    },
    send: {
      type: String
    }
  },
  data () {
    return {
      loading: true,
      dataSent: false,
      formTextarea: ''
    }
  },
  computed: {
    logoProviderFeedback () {
      return this.$store.getters.logoProviderFeedback
    },
    defaultMessageHeader () {
      return this.type.toLowerCase().trim() === 'sindico' ? 'A Administradora não divulgará a oferta aos condôminos.' : 'Os condôminos não serão notificados.'
    },
    defaultMessageBody () {
      return this.type.toLowerCase().trim() === 'sindico' ? 'Por favor, para melhoria dos nossos serviços gostaríamos que informasse o motivo.' : 'Caso queira comentar o motivo, agradecemos.'
    }
  },
  mounted () {
    var data = {
      token: this.token,
      type: this.type,
      send: this.send
    }
    this.$store.dispatch('getAllInfoFeedback', data)
        .then((response) => {
          this.loading = false
        })
        .catch((err) => console.log(err))
    if (this.send === 'false') {
      this.$store.dispatch('sendEmailToCondominiums', data)
        .then((response) => {
          this.loading = false
        })
        .catch((err) => console.log(err))
    }
  },
  methods: {
    sendFormData () {
      // REVIEW: transição não ta sendo feita =/
      // this.dataSent = !this.dataSent
      // return
      // BUG: ta falso fixo, arrumar na API
      this.$store.commit('updateSatisfaction', false)
      this.$store.commit('updateObservation', this.formTextarea)

      this.$store.dispatch('sendHotsiteFeedback', this.token)
        .then(({ data }) => {
          this.dataSent = true
        })
        .catch((err) => console.log(err))
    }
  }
}
</script>

<style lang="css">
.theme--light .card, .application .theme--light.card{
    background-color: #fff;
    color: rgba(67, 95, 199, 0.87);
    margin-top: 5%;
}
.logo-header{
    position: relative;
    width: 100%;
    text-align: center;
    padding: 20px;
    min-height: 145.63px;
    background-color: #fff;
}
.logo-header img, .administrator{
  max-width: 200px;
  max-height: 100px;
}
.titulo-logo{
  width: 300px;
  margin: auto;
}
.titulo-logo h4 {
  width: calc(100% - 80px);
  color: #a2a2a2;
  float: left;
  position: relative;
  top: 11px;
  font-size: 39px;
  left: 2px;
}
.titulo-logo img {
  width: 80px;
  height: 80px;
  float: left;
}
.progrees-line{
  position: absolute;
  bottom:0;
  margin: 0;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// feedback.vue?ea4b4298